var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyRatingStar = function SvgEmptyRatingStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 46,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#FFC401",
    d: "m24 1.13 6.899 13.979.116.235.26.038 15.427 2.242-11.163 10.88-.188.184.044.26 2.636 15.363-13.798-7.254-.233-.122-.233.122L9.97 44.311l2.636-15.364.044-.259-.188-.183L1.298 17.624l15.427-2.242.26-.038.116-.235L24 1.129Z"
  })));
};
export default SvgEmptyRatingStar;